import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import { TranscriptHeaderPercentContainer } from './TranscriptHeaderPercentContainer';

export const TranscriptHeaderFillerWords = ({ percent }: { percent?: string }) => {
  const { t } = useTranslation('components', { keyPrefix: 'transcript' });

  return (
    <Box display="flex" mr={4} alignItems="center">
      <Typography variant="text3" mr={1}>
        {t('filler')}
      </Typography>
      <Box>
        {Number(percent) === 0 ? (
          <TranscriptHeaderPercentContainer>{t('allGood')}</TranscriptHeaderPercentContainer>
        ) : (
          <TranscriptHeaderPercentContainer>{`${Math.round(Number(percent))}%`}</TranscriptHeaderPercentContainer>
        )}
      </Box>
    </Box>
  );
};
